<template>
  <PDVLaudosPendingPage type="entrada" />
</template>

<script setup lang="ts">
import PDVLaudosPendingPage from './PDVLaudosPendingPage.vue';
</script>
